export enum ValidationType {
  Full = 'full',
  Draft = 'draft',
}
